import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';

@Component({
  selector: 'app-rendition-form-load-draft',
  templateUrl: './rendition-form-load-draft.component.html',
  styleUrls: ['./rendition-form-load-draft.component.scss'],
})
export class RenditionFormLoadDraftComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: any;
  address = '';

  ngOnInit(): void {
    if (this.value) {
      this.address = this.value.value;

      const dialogEvent = {
        isButtonActionDisabled: false,
        value: this.value,
      };

      this.dialogChange.emit(dialogEvent);
    }
  }
}
